import { MDBContainer } from "mdb-react-ui-kit";
import { useState, useEffect } from "react";

//common component
import Header from "../../components/header/header-one";
import QRCodeScanner from "../../components/modal/qr.code.scanner";
import Sidebar from "../../components/sidebar/sidebar-one";

//component
import AgentListing from "./component/agent.listing";
import CreateModalBox from "./component/create.mdalbox";

//api service
import apiServices from "../../services/api.services";
import useWindowDimensions from "../../components/common/window-dimension";

export default function Agent() {
  //data for api
  const [type, setType] = useState("agent"); //control role
  const [start, setStart] = useState(0); //paginate
  const [length, setLength] = useState(10); //paginate
  const [order, setOrder] = useState("desc"); // asc or desc
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(); //filter date
  const [endDate, setEndDate] = useState(); //filter date
  //handle modalbox
  const [createModal, setCreateModal] = useState(false);
  //date for render
  const [listingData, setListingData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayRecords, setDisplayRecords] = useState(0);
  //handle apply filter
  const [handleApplyFilter, setHandleApplyFilter] = useState(false);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width >= "767") {
      setOpenSideBar(true);
    } else {
      setOpenSideBar(false);
    }
  }, [width]);

  const getListing = async () => {
    const response = await apiServices.getAllListing({
      api_name: "user",
      type,
      search,
      order,
      startDate,
      endDate,
      length,
      start,
    });
    if (response) {
      setListingData(response.aaData);
      setTotalRecords(response.iTotalRecords);
      setDisplayRecords(response.iTotalDisplayRecords);
    }
  };

  useEffect(() => {
    getListing();
  }, [search, length, handleApplyFilter, start]);

  const [openSideBar, setOpenSideBar] = useState(true);

  const handleOpenSideBar = () => {
    setOpenSideBar(!openSideBar);
  };

  const createAble = () => {
    setCreateModal(!createModal);
  };

  return (
    <MDBContainer className="main-container" breakpoint="none">
      <div className="grid-container">
        <Sidebar isOpen={openSideBar} handleSideBar={handleOpenSideBar} />
        {createModal && (
          <CreateModalBox
            show={true}
            title="Create Agent"
            close={createAble}
            getListing={getListing}
          />
        )}
        <div className="page-container">
          <Header handleSideBar={handleOpenSideBar} />
          <AgentListing
            length={length}
            start={start}
            createAble={createAble}
            listingData={listingData}
            totalRecords={totalRecords}
            displayRecords={displayRecords}
            setListingData={setListingData}
            setSearch={setSearch}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setOrder={setOrder}
            setLength={setLength}
            setStart={setStart}
            getListing={getListing}
          />
        </div>
      </div>
    </MDBContainer>
  );
}
